export default __webpack_public_path__ + "static/media/dinas.05851670.png";